import { render } from "./ProductCategories.vue?vue&type=template&id=0fc78d7c"
import script from "./ProductCategories.vue?vue&type=script&lang=ts"
export * from "./ProductCategories.vue?vue&type=script&lang=ts"

import "./ProductCategories.vue?vue&type=style&index=0&id=0fc78d7c&lang=css"
script.render = render

export default script